import { render, staticRenderFns } from "./PriceGenerate.vue?vue&type=template&id=66ef3401&scoped=true&"
import script from "./PriceGenerate.vue?vue&type=script&lang=js&"
export * from "./PriceGenerate.vue?vue&type=script&lang=js&"
import style0 from "./PriceGenerate.vue?vue&type=style&index=0&id=66ef3401&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ef3401",
  null
  
)

export default component.exports